/* @flow */
import { Observable } from 'rxjs';
import { ActionsObservable } from 'redux-observable';
import { combineEpics } from 'redux-observable';
import createDebugger from 'debug';

const debug = createDebugger('app:modules:roles:epics'); // eslint-disable-line no-unused-vars

import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,
} from './action-types.js';
import { INITIALIZE } from 'modules/app/action-types.js';

export const ENDPOINT = '/services/roles';

// TODO: Throwaway typings are in here to simply get this out the door without
// taking the time to accurately type it
const fetchEpic = (action$: ActionsObservable<*>, store: any, { ajax }: any) =>
  action$.ofType(FETCH)
    .switchMap(() =>
      ajax.get(ENDPOINT)
        .map(({ response }) => ({
          type: FETCH_SUCCESS,
          payload: response,
        }))
        .catch(err => Observable.of({
          type: FETCH_FAILURE,
          error: true,
          payload: err,
          meta: {
            alert: { type: 'error', text: 'Roles could not be fetched.' },
          },
        })));

const initializeEpic = (action$: ActionsObservable<*>, store: any, { ajax }: any) =>
  action$.ofType(INITIALIZE)
    .mergeMap(() => Observable.of({
      type: FETCH,
    })
  );

export default combineEpics(
  fetchEpic,
  initializeEpic,
);



// WEBPACK FOOTER //
// ./src/app/modules/roles/epics.js